import { render, staticRenderFns } from "./DisplayPlayerWord.vue?vue&type=template&id=f1e1ef98&"
import script from "./DisplayPlayerWord.vue?vue&type=script&lang=js&"
export * from "./DisplayPlayerWord.vue?vue&type=script&lang=js&"
import style0 from "./DisplayPlayerWord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports